const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "clippath"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M51.0358 98.8405C77.9837 98.8405 99.8293 77.0387 99.8293 50.1449C99.8293 23.251 77.9837 1.44922 51.0358 1.44922C24.0878 1.44922 2.24219 23.251 2.24219 50.1449C2.24219 77.0387 24.0878 98.8405 51.0358 98.8405Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0_2000_53263)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M100.5 49.6098C100.5 52.4415 100.254 55.2062 99.7851 57.9041C97.5286 71.2598 89.9326 82.8317 79.2534 90.2787C75.7682 92.709 71.9701 94.7157 67.904 96.1873C62.5644 98.1717 56.778 99.2196 50.7682 99.2196C26.9522 99.2196 7.04608 82.4972 2.198 60.1561C1.46074 56.767 1.05859 53.2219 1.05859 49.5875C1.05859 22.2074 23.3106 0 50.7682 0C78.2257 0 100.5 22.2074 100.5 49.6098Z",
  fill: "url(#paint0_linear_2000_53263)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M99.0925 62.1179C94.0657 84.4591 74.45 100.022 50.5447 100.022C24.0255 99.9997 2.30965 79.4869 0.5 53.4668C8.45353 51.148 20.4508 51.1926 36.7154 64.6597C64.508 87.6475 94.5125 77.012 99.0925 62.0956V62.1179Z",
  fill: "#D6F5FF"
})));

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M61.0478 82.7874C59.1711 83.4117 58.6573 83.9245 58.0317 85.7974C57.4062 83.9245 56.8923 83.4117 55.0156 82.7874C56.8923 82.1631 57.4062 81.6503 58.0317 79.7773C58.6573 81.6503 59.1711 82.1631 61.0478 82.7874Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M61.0478 82.7874C59.1711 83.4117 58.6573 83.9245 58.0317 85.7974C57.4062 83.9245 56.8923 83.4117 55.0156 82.7874C56.8923 82.1631 57.4062 81.6503 58.0317 79.7773C58.6573 81.6503 59.1711 82.1631 61.0478 82.7874Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M22.5 46.5C20.3222 47.2259 19.7259 47.8222 19 50C18.2741 47.8222 17.6778 47.2259 15.5 46.5C17.6778 45.7741 18.2741 45.1778 19 43C19.7259 45.1778 20.3222 45.7741 22.5 46.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M83.5 31.5C81.9444 32.0185 81.5185 32.4444 81 34C80.4815 32.4444 80.0556 32.0185 78.5 31.5C80.0556 30.9815 80.4815 30.5556 81 29C81.5185 30.5556 81.9444 30.9815 83.5 31.5Z",
  fill: "white"
}));

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Rectangle 156",
  filter: "url(#filter0_d_2000_53263)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M70.5 70.5V22C70.5 20.8954 69.6046 20 68.5 20H50.5H40.5H38.9905C38.3664 20 37.778 20.2914 37.3997 20.7879L30.9091 29.3068C30.6437 29.6551 30.5 30.0809 30.5 30.5188V33.125V46.25V70.5C30.5 71.6046 31.3954 72.5 32.5 72.5H68.5C69.6046 72.5 70.5 71.6046 70.5 70.5Z",
  fill: "white"
}));

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  id: "Intersect",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.5 32.5H38.5C39.6046 32.5 40.5 31.6046 40.5 30.5V20H38.9905C38.3664 20 37.778 20.2914 37.3997 20.7879L30.9091 29.3068C30.6437 29.6551 30.5 30.0809 30.5 30.5188V32.5Z",
  fill: "url(#paint1_linear_2000_53263)"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  id: "Rectangle 160",
  x: 45.5,
  y: 27.5,
  width: 20,
  height: 3,
  rx: 1,
  fill: "#009FEB"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  id: "Rectangle 161",
  x: 45.5,
  y: 35,
  width: 20,
  height: 3,
  rx: 1,
  fill: "#009FEB"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  id: "Rectangle 162",
  x: 35.5,
  y: 42.5,
  width: 30,
  height: 3,
  rx: 1,
  fill: "#CBF2FE"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  id: "Rectangle 163",
  x: 35.5,
  y: 50,
  width: 30,
  height: 3,
  rx: 1,
  fill: "#CBF2FE"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  id: "Rectangle 164",
  x: 35.5,
  y: 57.5,
  width: 18.75,
  height: 3,
  rx: 1,
  fill: "#CBF2FE"
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  id: "Group 26"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 167",
  x: 25.5,
  y: 18,
  width: 51,
  height: 2,
  fill: "#DED807"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 168",
  x: 25.5,
  y: 20,
  width: 51,
  height: 7,
  fill: "url(#paint2_linear_2000_53263)"
}));

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_2000_53263",
  x: 26.5,
  y: 18,
  width: 48,
  height: 60.5,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0.623529 0 0 0 0 0.921569 0 0 0 0.35 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_2000_53263"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_2000_53263",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2000_53263",
  x1: 39.7985,
  y1: 103.969,
  x2: 65.1473,
  y2: -22.0487,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#48D0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#94E4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#C3F0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#D6F5FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2000_53263",
  x1: 35.5,
  y1: 28.125,
  x2: 41.125,
  y2: 33.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F2FBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B5ECFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_2000_53263",
  x1: 51,
  y1: 20,
  x2: 51,
  y2: 27,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DED807",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DED807",
  stopOpacity: 0
})));

const SvgProcessingQuestion = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2000_53263",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 98,
    height: 98
  }, _ref2), _ref3), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12), _ref13);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProcessingQuestion, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/processing-question.f5daa4f2.svg";
export { ForwardRef as ReactComponent };